import { render, staticRenderFns } from "./modal_iniciar_consulta_telemedicina.vue?vue&type=template&id=8ed3dce4&scoped=true&"
import script from "./modal_iniciar_consulta_telemedicina.vue?vue&type=script&lang=js&"
export * from "./modal_iniciar_consulta_telemedicina.vue?vue&type=script&lang=js&"
import style0 from "./modal_iniciar_consulta_telemedicina.vue?vue&type=style&index=0&id=8ed3dce4&scoped=true&lang=css&"
import style1 from "./modal_iniciar_consulta_telemedicina.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed3dce4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VContainer,VDialog,VIcon,VProgressCircular,VSpacer,VTextField,VToolbar,VToolbarTitle})
